import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var warned = {};
var warnOnce = function warnOnce(message) {
  if (!warned[message]) {
    /* istanbul ignore else */
    if (typeof console !== 'undefined') {
      console.error(message); // eslint-disable-line no-console
    }

    warned[message] = true;
  }
};
var deprecated = function deprecated(propType, explanation) {
  return function (props, propName, componentName) {
    if (props[propName] !== null && typeof props[propName] !== 'undefined') {
      warnOnce("\"".concat(propName, "\" property of \"").concat(componentName, "\" has been deprecated.\n").concat(explanation));
    }

    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    return propType.apply(void 0, [props, propName, componentName].concat(rest));
  };
}; // In NODE_ENV=production the Transition.propTypes are wrapped which results in an

var _excluded$1 = ["actionLink", "aux", "floatingAction", "outline", "textonly", "active", "block", "children", "className", "close", "color", "disabled", "icononly", "type", "size", "tag", "innerRef", "variant", "onClick"];
function useButton(props) {
  var _classNames;

  var actionLink = props.actionLink,
      aux = props.aux,
      floatingAction = props.floatingAction,
      outline = props.outline,
      textonly = props.textonly,
      active = props.active,
      block = props.block,
      children = props.children,
      className = props.className,
      close = props.close,
      color = props.color,
      disabled = props.disabled,
      icononly = props.icononly,
      type = props.type,
      size = props.size,
      tag = props.tag,
      innerRef = props.innerRef,
      variantFromProps = props.variant,
      onClick = props.onClick,
      attributes = _objectWithoutProperties(props, _excluded$1); // Returns the name (string) of the first deprecated prop that is truthy


  var getVariantFromProps = function getVariantFromProps(deprecatedVariantProps) {
    return Object.keys(deprecatedVariantProps).find(function (key) {
      return !!deprecatedVariantProps[key];
    });
  }; // Map deprecated props to `variant` constant


  var variant = variantFromProps || getVariantFromProps({
    floatingAction: floatingAction,
    outline: outline,
    aux: aux,
    textonly: textonly,
    actionLink: actionLink
  });
  var Tag = tag || (attributes.href ? 'a' : 'button'); // Type depends on the Tag - default is <button type="button" />

  var computedType = type || (Tag === 'button' ? 'button' : null);
  var computedSize = size || (icononly ? 'sm' : '');
  var classes = classNames((_classNames = {}, _defineProperty(_classNames, className, className), _defineProperty(_classNames, "close", close), _defineProperty(_classNames, "btn", !close && variant !== 'actionLink'), _defineProperty(_classNames, "btn-".concat(computedSize), !close && computedSize), _defineProperty(_classNames, "btn-".concat(color), !close && color), _defineProperty(_classNames, "disabled", disabled), _defineProperty(_classNames, "active", active), _defineProperty(_classNames, 'btn-icon-only', icononly && variant !== 'floatingAction'), _defineProperty(_classNames, 'btn-block', block && variant !== 'floatingAction'), _defineProperty(_classNames, 'btn-action-link', variant === 'actionLink'), _defineProperty(_classNames, "link", variant === 'actionLink'), _defineProperty(_classNames, 'btn-floating-action', variant === 'floatingAction'), _defineProperty(_classNames, 'btn-auxiliary', variant === 'aux'), _defineProperty(_classNames, 'btn-outline', variant === 'outline'), _defineProperty(_classNames, 'btn-textonly', variant === 'textonly' || variant === 'aux'), _classNames));

  var handleOnClick = function handleOnClick(e) {
    if (!onClick || !e) return;

    if (!props.href && e) {
      e.preventDefault();
    }

    onClick(e);
  };

  var tagProps = _objectSpread2(_objectSpread2({}, attributes), {}, {
    type: computedType,
    disabled: disabled,
    className: classes,
    ref: innerRef,
    onClick: handleOnClick
  });

  if (!attributes['aria-label'] && close) {
    tagProps['aria-label'] = 'Close';
  } // Flag indicating the button should render as a standard 'close' button


  var isClose = close && !children;
  return {
    Tag: Tag,
    tagProps: tagProps,
    isClose: isClose,
    children: children
  };
}

/* eslint-disable react/jsx-filename-extension */

var Button = function Button(props) {
  var _useButton = useButton(props),
      Tag = _useButton.Tag,
      tagProps = _useButton.tagProps,
      isClose = _useButton.isClose,
      children = _useButton.children;

  return /*#__PURE__*/React.createElement(Tag, tagProps, isClose ? /*#__PURE__*/React.createElement("span", {
    "aria-hidden": true
  }, "\xD7") : children);
};

var ButtonVariants = ['actionLink', 'aux', 'floatingAction', 'outline', 'textonly'];
Button.propTypes = {
  actionLink: deprecated(PropTypes.bool, 'Please use prop `variant` with value `actionLink`'),
  aux: deprecated(PropTypes.bool, 'Please use prop `variant` with value `aux`'),
  floatingAction: deprecated(PropTypes.bool, 'Please use prop `variant` with value `floatingAction`'),
  outline: deprecated(PropTypes.bool, 'Please use prop `variant` with value `outline`'),
  textonly: deprecated(PropTypes.bool, 'Please use prop `variant` with value `textonly`'),
  active: PropTypes.bool,
  block: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  close: PropTypes.bool,
  color: PropTypes.string,
  disabled: PropTypes.bool,
  icononly: PropTypes.bool,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.func, PropTypes.string]),
  onClick: PropTypes.func,
  size: PropTypes.string,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  type: PropTypes.string,
  variant: PropTypes.oneOf([undefined].concat(ButtonVariants))
};
Button.defaultProps = {
  actionLink: undefined,
  // deprecated
  aux: undefined,
  // deprecated
  floatingAction: undefined,
  // deprecated
  outline: undefined,
  // deprecated
  textonly: undefined,
  // deprecated
  active: false,
  block: false,
  children: null,
  className: undefined,
  close: false,
  color: undefined,
  disabled: false,
  icononly: false,
  innerRef: null,
  onClick: undefined,
  size: undefined,
  tag: undefined,
  type: undefined,
  variant: undefined
};

var _excluded = ["color", "outline"];

var FloatingButton = function FloatingButton(props) {
  var color = props.color,
      outline = props.outline,
      attributes = _objectWithoutProperties(props, _excluded);

  var className = '';

  if (outline || color) {
    className += 'btn';

    if (outline) {
      className += '-outline';
    }

    if (color) {
      className += "-".concat(color);
    }
  }

  return /*#__PURE__*/React.createElement(Button, _extends({
    className: className
  }, attributes));
};

FloatingButton.propTypes = {
  color: PropTypes.string,
  outline: PropTypes.bool
};
FloatingButton.defaultProps = {
  color: undefined,
  outline: false
};

Button.Floating = FloatingButton;

export { FloatingButton, Button as default };
//# sourceMappingURL=index.js.map
